module.exports = {
	"Vanguard Target Retirement Series": [
		[
			"Vanguard Target Retirement 2070 Fund",
			"FS0000HDIC",
			"~",
			0.08065051670444207,
			0.003427553979761855,
			0.08407807068420392
		],
		[
			"Vanguard Target Retirement 2065 Fund",
			"FS0000D17J",
			"~",
			0.08019566005615357,
			0.0031660668875217067,
			0.08336172694367527
		],
		[
			"Vanguard Target Retirement 2060 Fund",
			"FS00008YI2",
			"~",
			0.08036342163620322,
			0.0032255517799972596,
			0.08358897341620047
		],
		[
			"Vanguard Target Retirement 2055 Fund",
			"FSUSA0AWPD",
			"~",
			0.08032666379393759,
			0.00326181821755119,
			0.08358848201148877
		],
		[
			"Vanguard Target Retirement 2050 Fund",
			"FSUSA072BK",
			"~",
			0.08024700579457168,
			0.003268008966211633,
			0.08351501476078331
		],
		[
			"Vanguard Target Retirement 2045 Fund",
			"FSUSA04C61",
			"~",
			0.0758893350582794,
			0.004623421317086152,
			0.08051275637536555
		],
		[
			"Vanguard Target Retirement 2040 Fund",
			"FSUSA072BI",
			"~",
			0.06823506026662908,
			0.007062568740663622,
			0.0752976290072927
		],
		[
			"Vanguard Target Retirement 2035 Fund",
			"FSUSA04C62",
			"~",
			0.06116514924323183,
			0.00930723295448306,
			0.0704723821977149
		],
		[
			"Vanguard Target Retirement 2030 Fund",
			"FSUSA072BH",
			"~",
			0.05426274087980579,
			0.011496230679006621,
			0.06575897155881241
		],
		[
			"Vanguard Target Retirement 2025 Fund",
			"FSUSA04C63",
			"~",
			0.04647789761877514,
			0.012926504408448546,
			0.059404402027223684
		],
		[
			"Vanguard Target Retirement 2020 Fund",
			"FSUSA072BG",
			"~",
			0.035230489202590476,
			0.014566823354659747,
			0.04979731255725022
		],
		[
			"Vanguard Target Retirement Income",
			"FSUSA04BYK",
			"~",
			0.02420873589822837,
			0.016543257559609954,
			0.04075199345783832
		]
	],
	"BlackRock LifePath Index": [
		[
			"BlackRock LifePath® Index 2065 Fund",
			"FS0000FCWA",
			"~",
			0.08654592535593908,
			0.0019195903309161824,
			0.08846551568685526
		],
		[
			"BlackRock LifePath® Index 2060 Fund",
			"FS0000C8VF",
			"~",
			0.08670656047888761,
			0.0016559941738530904,
			0.0883625546527407
		],
		[
			"BlackRock LifePath® Index 2055 Fund",
			"FSUSA0BDPT",
			"~",
			0.08675189738403444,
			0.0015049406496713052,
			0.08825683803370574
		],
		[
			"BlackRock LifePath® Index 2050 Fund",
			"FSUSA0BDPU",
			"~",
			0.08471012883200901,
			0.004415330955539908,
			0.08912545978754892
		],
		[
			"BlackRock LifePath® Index 2045 Fund",
			"FSUSA0BDPV",
			"~",
			0.07866477829716315,
			0.008302856189532203,
			0.08696763448669535
		],
		[
			"BlackRock LifePath® Index 2040 Fund",
			"FSUSA0BDPW",
			"~",
			0.06965019365638501,
			0.010014212303853631,
			0.07966440596023865
		],
		[
			"BlackRock LifePath® Index 2035 Fund",
			"FSUSA0BDPX",
			"~",
			0.05940459449733448,
			0.012372868585268242,
			0.07177746308260272
		],
		[
			"BlackRock LifePath® Index 2030 Fund",
			"FSUSA0BDPY",
			"~",
			0.04871285292100014,
			0.014160420067164935,
			0.06287327298816507
		],
		[
			"BlackRock LifePath® Index 2025 Fund",
			"FSUSA0BDPZ",
			"~",
			0.03700173818270401,
			0.014567211240572073,
			0.051568949423276084
		],
		[
			"BlackRock LifePath® Index Retirement Fund",
			"FSUSA0BDPS",
			"~",
			0.032011560110599045,
			0.014213872858253112,
			0.046225432968852155
		]
	],
	"T. Rowe Price Retirement Series": [
		[
			"T. Rowe Price Retirement 2065 Fund",
			"FS0000G0EV",
			"~",
			0.07806994425862915,
			0.0002592726907538679,
			0.07832921694938301
		],
		[
			"T. Rowe Price Retirement 2060 Fund",
			"FS0000AOEU",
			"~",
			0.07767173056805268,
			0.0002557631270544299,
			0.07792749369510711
		],
		[
			"T. Rowe Price Retirement 2055 Fund",
			"FSUSA07VNU",
			"~",
			0.0777479202277828,
			0.0002564644226942413,
			0.07800438465047704
		],
		[
			"T. Rowe Price Retirement 2050 Fund",
			"FSUSA07VNR",
			"~",
			0.07706701077861977,
			0.0002542667347442549,
			0.07732127751336403
		],
		[
			"T. Rowe Price Retirement 2045 Fund",
			"FSUSA06ALQ",
			"~",
			0.0758805333888774,
			0.000610380574419743,
			0.07649091396329714
		],
		[
			"T. Rowe Price Retirement 2040 Fund",
			"FSUSA00IKV",
			"~",
			0.07108511849095803,
			0.0025870968840735814,
			0.0736722153750316
		],
		[
			"T. Rowe Price Retirement 2035 Fund",
			"FSUSA04WWU",
			"~",
			0.06280618735226419,
			0.006230772697966531,
			0.06903696005023072
		],
		[
			"T. Rowe Price Retirement 2030 Fund",
			"FSUSA00IKU",
			"~",
			0.05346417298331525,
			0.010217225750691004,
			0.06368139873400626
		],
		[
			"T. Rowe Price Retirement 2025 Fund",
			"FSUSA04WWT",
			"~",
			0.04454610900182352,
			0.013662544600876634,
			0.05820865360270015
		],
		[
			"T. Rowe Price Retirement 2020 Fund",
			"FSUSA00IKT",
			"~",
			0.03896737715584961,
			0.01601524401261812,
			0.05498262116846773
		],
		[
			"T. Rowe Price Retirement 2015 Fund",
			"FSUSA04WWS",
			"~",
			0.036351302616986436,
			0.01669395071816623,
			0.05304525333515267
		],
		[
			"T. Rowe Price Retirement 2010 Fund",
			"FSUSA00IKS",
			"~",
			0.03398477448010643,
			0.01723055890743696,
			0.05121533338754339
		],
		[
			"T. Rowe Price Retirement 2005 Fund",
			"FSUSA04WWR",
			"~",
			0.03113399984904949,
			0.0180240645308849,
			0.04915806437993439
		]
	],
	"BlackRock LifePath ESG Index Series": [
		[
			"BlackRock LifePath ESG Index 2065 Fund",
			"FS0000G100",
			"~",
			0.07589900172136489,
			0.00034590213208103386,
			0.07624490385344593
		],
		[
			"BlackRock LifePath ESG Index 2060 Fund",
			"FS0000G108",
			"~",
			0.0759479120794478,
			0.0003004551741402501,
			0.07624836725358805
		],
		[
			"BlackRock LifePath ESG Index 2055 Fund",
			"FS0000G107",
			"~",
			0.07593412738380441,
			0.0002659681198778261,
			0.07620009550368223
		],
		[
			"BlackRock LifePath ESG Index 2050 Fund",
			"FS0000G106",
			"~",
			0.07433688714139106,
			0.0007791634619226331,
			0.0751160506033137
		],
		[
			"BlackRock LifePath ESG Index 2045 Fund",
			"FS0000G105",
			"~",
			0.06921609607170974,
			0.0024083494810121153,
			0.07162444555272185
		],
		[
			"BlackRock LifePath ESG Index 2040 Fund",
			"FS0000G104",
			"~",
			0.06131370516682,
			0.005183210505624398,
			0.0664969156724444
		],
		[
			"BlackRock LifePath ESG Index 2035 Fund",
			"FS0000G103",
			"~",
			0.05278117273223942,
			0.008403600976695525,
			0.06118477370893495
		],
		[
			"BlackRock LifePath ESG Index 2030 Fund",
			"FS0000G102",
			"~",
			0.0438528298877389,
			0.01181043584665743,
			0.055663265734396325
		],
		[
			"BlackRock LifePath ESG Index 2025 Fund",
			"FS0000G101",
			"~",
			0.03400201720890456,
			0.015649157382522153,
			0.04965117459142672
		],
		[
			"BlackRock LifePath ESG Index Retirement Fund",
			"FS0000G0ZZ",
			"~",
			0.02962913013063446,
			0.017256077297431432,
			0.04688520742806589
		]
	],
	"Natixis Sustainable Future Series": [
		[
			"Natixis Sustainable Future 2065 Fund",
			"FS0000H5P1",
			"~",
			0.04156699541628039,
			0.005114797713258576,
			0.04668179312953896
		],
		[
			"Natixis Sustainable Future 2060 Fund",
			"FS0000D06X",
			"~",
			0.04080542358835302,
			0.005470819703385504,
			0.046276243291738524
		],
		[
			"Natixis Sustainable Future 2055 Fund",
			"FS0000D089",
			"~",
			0.04082001970868893,
			0.005405918545194145,
			0.046225938253883075
		],
		[
			"Natixis Sustainable Future 2050 Fund",
			"FS0000D088",
			"~",
			0.039539799814002456,
			0.006846575525743702,
			0.046386375339746155
		],
		[
			"Natixis Sustainable Future 2045 Fund",
			"FS0000D087",
			"~",
			0.038312009383911,
			0.00866356855663834,
			0.04697557794054934
		],
		[
			"Natixis Sustainable Future 2040 Fund",
			"FS0000D086",
			"~",
			0.03576301194723599,
			0.01364635582698825,
			0.049409367774224236
		],
		[
			"Natixis Sustainable Future 2035 Fund",
			"FS0000D071",
			"~",
			0.03239070779268048,
			0.0189344241266935,
			0.05132513191937398
		],
		[
			"Natixis Sustainable Future 2030 Fund",
			"FS0000D070",
			"~",
			0.02833858890030322,
			0.025456973133129227,
			0.05379556203343244
		],
		[
			"Natixis Sustainable Future 2025 Fund",
			"FS0000D06Z",
			"~",
			0.024385859454802455,
			0.029525152686577853,
			0.053911012141380305
		],
		[
			"Natixis Sustainable Future 2020 Fund",
			"FS0000D06Y",
			"~",
			0.02137333424745164,
			0.03170269119859765,
			0.053076025446049294
		],
		[
			"Natixis Sustainable Future 2015 Fund",
			"FS0000D06W",
			"~",
			0.016833988327813337,
			0.03439250205887755,
			0.05122649038669089
		]
	],
	"American Funds Trgt Date Rtrmt Series": [
		[
			"American Funds 2065 Target Date Retirement Fund",
			"FS0000FO2E",
			"~",
			0.06575802466176081,
			0.0014457689799359092,
			0.06720379364169672
		],
		[
			"American Funds 2060 Target Date Retirement Fund®",
			"FS0000B7PP",
			"~",
			0.06575939476613868,
			0.0014457162045748392,
			0.06720511097071352
		],
		[
			"American Funds 2055 Target Date Retirement Fund®",
			"FSUSA0A8YJ",
			"~",
			0.0661437947201498,
			0.001444672014620903,
			0.06758846673477072
		],
		[
			"American Funds 2050 Target Date Retirement Fund®",
			"FSUSA07X4H",
			"~",
			0.06765038436101971,
			0.0019246269670638659,
			0.06957501132808358
		],
		[
			"American Funds 2045 Target Date Retirement Fund®",
			"FSUSA07X4G",
			"~",
			0.06926289745234807,
			0.0026960726332364037,
			0.07195897008558447
		],
		[
			"American Funds 2040 Target Date Retirement Fund®",
			"FSUSA07X4E",
			"~",
			0.06752044360848247,
			0.005157122189947446,
			0.07267756579842992
		],
		[
			"American Funds 2035 Target Date Retirement Fund®",
			"FSUSA07X4D",
			"~",
			0.0606185753287856,
			0.008963073925132462,
			0.06958164925391806
		],
		[
			"American Funds 2030 Target Date Retirement Fund®",
			"FSUSA07X4B",
			"~",
			0.05324412747787995,
			0.013704030863810534,
			0.06694815834169049
		],
		[
			"American Funds 2025 Target Date Retirement Fund®",
			"FSUSA07X47",
			"~",
			0.04945308378602265,
			0.021195241646181348,
			0.070648325432204
		],
		[
			"American Funds 2020 Target Date Retirement Fund®",
			"FSUSA07X44",
			"~",
			0.04960728915687859,
			0.02603286303361477,
			0.07564015219049336
		],
		[
			"American Funds 2015 Target Date Retirement Fund®",
			"FSUSA07X42",
			"~",
			0.04901370167454994,
			0.028314059774986716,
			0.07732776144953665
		],
		[
			"American Funds 2010 Target Date Retirement Fund®",
			"FSUSA07X41",
			"~",
			0.048634954570147874,
			0.025852638967524696,
			0.07448759353767256
		]
	],
	"Fidelity Freedom Series": [
		[
			"Fidelity Freedom® 2065 Fund",
			"FS0000F7H7",
			"~",
			0.09028395009102358,
			0.0017878247485627666,
			0.09207177483958634
		],
		[
			"Fidelity Freedom® 2060 Fund",
			"FS0000ASQS",
			"~",
			0.090280029847377,
			0.0017486774199631824,
			0.09202870726734018
		],
		[
			"Fidelity Freedom® 2055 Fund",
			"FSUSA0BGO9",
			"~",
			0.0902785809542053,
			0.0017463961533051246,
			0.09202497710751043
		],
		[
			"Fidelity Freedom® 2050 Fund",
			"FSUSA0720M",
			"~",
			0.09027333137704308,
			0.001752032175112888,
			0.09202536355215596
		],
		[
			"Fidelity Freedom® 2045 Fund",
			"FSUSA0720L",
			"~",
			0.09027320914506011,
			0.0017517019015951115,
			0.09202491104665522
		],
		[
			"Fidelity Freedom® 2040 Fund",
			"FSUSA0040I",
			"~",
			0.08743047942872753,
			0.0029806994807069077,
			0.09041117890943444
		],
		[
			"Fidelity Freedom® 2035 Fund",
			"FSUSA04C0Q",
			"~",
			0.07384831334725006,
			0.008887888786927698,
			0.08273620213417776
		],
		[
			"Fidelity Freedom® 2030 Fund",
			"FSUSA00487",
			"~",
			0.06042595128150008,
			0.013370682904067293,
			0.07379663418556737
		],
		[
			"Fidelity Freedom® 2025 Fund",
			"FSUSA04C0P",
			"~",
			0.05377736070655643,
			0.014846945003625852,
			0.06862430571018228
		],
		[
			"Fidelity Freedom® 2020 Fund",
			"FSUSA003HE",
			"~",
			0.046587711936816135,
			0.016921738138046982,
			0.06350945007486311
		],
		[
			"Fidelity Freedom® 2015 Fund",
			"FSUSA04C0N",
			"~",
			0.03741076317273422,
			0.0192321802435352,
			0.05664294341626942
		],
		[
			"Fidelity Freedom® 2010 Fund",
			"FSUSA00418",
			"~",
			0.028312939052573323,
			0.021579685931714387,
			0.04989262498428771
		],
		[
			"Fidelity Freedom® 2005 Fund",
			"FSUSA04C0M",
			"~",
			0.01954981898575447,
			0.023876308827535976,
			0.043426127813290444
		],
		[
			"Fidelity Freedom® Income Fund",
			"FSUSA0031V",
			"~",
			0.018561497166139203,
			0.02418167092037405,
			0.04274316808651325
		]
	],
	"TIAA-CREF Lifecycle Series": [
		[
			"TIAA-CREF Lifecycle 2065 Fund",
			"FS0000G495",
			"~",
			0.0853565236954847,
			0.0010982776130031666,
			0.08645480130848787
		],
		[
			"TIAA-CREF Lifecycle 2060 Fund",
			"FS0000AWCA",
			"~",
			0.08442771637832402,
			0.001963758747777542,
			0.08639147512610157
		],
		[
			"TIAA-CREF Lifecycle 2055 Fund",
			"FSUSA0BANO",
			"~",
			0.08325673705742054,
			0.0029078060842377437,
			0.08616454314165828
		],
		[
			"TIAA-CREF Lifecycle 2050 Fund",
			"FSUSA08I1X",
			"~",
			0.08211498181017621,
			0.003839024019038638,
			0.08595400582921485
		],
		[
			"TIAA-CREF Lifecycle 2045 Fund",
			"FSUSA08I1W",
			"~",
			0.07905175384544313,
			0.006358294918150401,
			0.08541004876359354
		],
		[
			"TIAA-CREF Lifecycle 2040 Fund",
			"FSUSA063RS",
			"~",
			0.07233729642230005,
			0.01185682107162624,
			0.08419411749392629
		],
		[
			"TIAA-CREF Lifecycle 2035 Fund",
			"FSUSA063RR",
			"~",
			0.06201927822546971,
			0.01934989860203245,
			0.08136917682750217
		],
		[
			"TIAA-CREF Lifecycle 2030 Fund",
			"FSUSA063RP",
			"~",
			0.05199001713650262,
			0.025736495230632383,
			0.077726512367135
		],
		[
			"TIAA-CREF Lifecycle 2025 Fund",
			"FSUSA063RO",
			"~",
			0.043644321629431715,
			0.030746453797023014,
			0.07439077542645472
		],
		[
			"TIAA-CREF Lifecycle 2020 Fund",
			"FSUSA063RN",
			"~",
			0.037392779849876275,
			0.03409536112238888,
			0.07148814097226516
		],
		[
			"TIAA-CREF Lifecycle 2015 Fund",
			"FSUSA063RM",
			"~",
			0.03284193222950581,
			0.03601490571617481,
			0.06885683794568062
		],
		[
			"TIAA-CREF Lifecycle 2010 Fund",
			"FSUSA063RL",
			"~",
			0.029672763289610833,
			0.03839553219486104,
			0.06806829548447188
		]
	],
	"JPMorgan SmartRetirement Series": [
		[
			"Jpmorgan Smartretirement 2065 Fund",
			"FS0000HSIR",
			"~",
			0.07626322219036788,
			0.004011291554480501,
			0.08027451374484838
		],
		[
			"JPMorgan SmartRetirement® 2060 Fund",
			"FS0000CKAS",
			"~",
			0.07828953458227937,
			0.004004701624355115,
			0.08229423620663448
		],
		[
			"JPMorgan SmartRetirement® 2055 Fund",
			"FS000090ET",
			"~",
			0.07888893177815319,
			0.004036197532701011,
			0.0829251293108542
		],
		[
			"JPMorgan SmartRetirement® 2050 Fund",
			"FSUSA08DFY",
			"~",
			0.07896523327581713,
			0.004040520799408417,
			0.08300575407522555
		],
		[
			"JPMorgan SmartRetirement® 2045 Fund",
			"FSUSA08DFX",
			"~",
			0.07671210346693923,
			0.0058925019233021375,
			0.08260460539024136
		],
		[
			"JPMorgan SmartRetirement® 2040 Fund",
			"FSUSA06R1T",
			"~",
			0.07050428117307235,
			0.010695640177689031,
			0.08119992135076139
		],
		[
			"JPMorgan SmartRetirement® 2035 Fund",
			"FSUSA08DFW",
			"~",
			0.06218574223281591,
			0.014562479974885972,
			0.07674822220770187
		],
		[
			"JPMorgan SmartRetirement® 2030 Fund",
			"FSUSA06R1S",
			"~",
			0.051510937210057964,
			0.02053224437575377,
			0.07204318158581173
		],
		[
			"JPMorgan SmartRetirement® 2025 Fund",
			"FSUSA08DFV",
			"~",
			0.04183227667726445,
			0.02515037514203567,
			0.06698265181930012
		],
		[
			"JPMorgan SmartRetirement® 2020 Fund",
			"FSUSA06R1R",
			"~",
			0.03525158984204006,
			0.02665477087117109,
			0.06190636071321115
		],
		[
			"JPMorgan SmartRetirement® Income Fund",
			"FSUSA06R1O",
			"~",
			0.035238997050761514,
			0.026533984804772995,
			0.06177298185553451
		]
	],
	"State Street Target Retirement Series": [
		[
			"State Street Target Retirement 2065 Fund",
			"FS0000FNM2",
			"~",
			0.07718880564108888,
			0,
			0.07718880564108888
		],
		[
			"State Street Target Retirement 2060 Fund",
			"FS0000AREC",
			"~",
			0.07736016010686746,
			0,
			0.07736016010686746
		],
		[
			"State Street Target Retirement 2055 Fund",
			"FS0000AREB",
			"~",
			0.07737939257684918,
			0,
			0.07737939257684918
		],
		[
			"State Street Target Retirement 2050 Fund",
			"FS0000AREA",
			"~",
			0.07742770194454436,
			0,
			0.07742770194454436
		],
		[
			"State Street Target Retirement 2045 Fund",
			"FS0000ARER",
			"~",
			0.07353804719777858,
			0.0017840486337746863,
			0.07532209583155326
		],
		[
			"State Street Target Retirement 2040 Fund",
			"FS0000AREQ",
			"~",
			0.0696744352632353,
			0.0035793863835610878,
			0.07325382164679639
		],
		[
			"State Street Target Retirement 2035 Fund",
			"FS0000AREP",
			"~",
			0.06343506950098053,
			0.01007701131099073,
			0.07351208081197126
		],
		[
			"State Street Target Retirement 2030 Fund",
			"FS0000AREO",
			"~",
			0.055831964909201365,
			0.013803506154101721,
			0.06963547106330309
		],
		[
			"State Street Target Retirement 2025 Fund",
			"FS0000AREN",
			"~",
			0.042905824517569094,
			0.01750419234773672,
			0.06041001686530581
		],
		[
			"State Street Target Retirement 2020 Fund",
			"FS0000AREM",
			"~",
			0.031187056804178985,
			0.020339529200778757,
			0.05152658600495774
		],
		[
			"State Street Target Retirement Fund",
			"FS0000AREK",
			"~",
			0.026807235092489928,
			0.02120797779882596,
			0.048015212891315884
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/TdFundsBonds.json
// module id = 1013
// module chunks = 0